import Extend from 'flarum/common/extenders';
import GlobalStats from 'flarum/gamilytics/common/models/GlobalStats';

export default [
	new Extend.Model(GlobalStats) //
		.attribute<number>('reviews')
		.attribute<number>('bookshelves'),
];
